<div class="input-group form-group-no-border filter-item d-flex justify-content-start">
    <label *ngIf="label" class="label text-end" [innerText]="label" [class.required-field]="required"></label>
    <div class="{{!label ? 'grey-border w-100' : 'w-200px'}} d-flex flex-column shadow">
        <textarea #textArea class="bg-default w-100 mr-n2 pl-2 border-0" rows="4"
        [(ngModel)]="value" (change)="valChange()" style="z-index: 99;" (focus)="onFocus()" (blur)="onBlur()"></textarea>
        <app-input-panel *ngIf="showInputPanel" class="bg-default w-100 mr-n2 p-0 border-0" 
        [cursorLocation]="cursorLocation" [(value)]="value" (valueChange)="valChange()"></app-input-panel>
    </div>
</div>